/**
 * Created by Ivan on 03.01.2025
 */

const BonusLevelChest = cc.Node.extend({
    ctor: function (options) {
        this._super();
        options = options || {};

        this.isVertical = options.isVertical;

        this.setAnchorPoint(0.5, 0.5);

        this.addColumn();
        this.addChest();

        if (options.timeLeft) {
            this.addTimer(options.timeLeft);
        }

        cleverapps.UI.wrap(this);
    },

    addColumn: function () {
        const spinePath = bundles.bonus_level.jsons[this.isVertical ? "bonus_cloud_vertical_json" : "bonus_cloud_horizontal_json"];
        if (!spinePath) {
            return;
        }
        const column = this.column = new cleverapps.Spine(spinePath);

        this.addChild(column);
        column.setAlignment(cleverapps.styles.BonusLevelChest.column);
        column.setAnimation(0, "animation", true);
    },

    addChest: function () {
        const styles = cleverapps.styles.BonusLevelChest.chest;

        const chestPath = bundles.bonus_level.jsons[this.isVertical ? "bonus_chest_vertical_json" : "bonus_chest_horizontal_json"];
        const chest = this.chest = new cleverapps.Spine(chestPath);
        chest.setAlignment(this.isVertical ? styles.vertical : styles);
        this.addChild(chest);
        chest.setAnimation(0, "animation", true);
    },

    addTimer: function (timeLeft) {
        const styles = cleverapps.styles.BonusLevelChest.timer;

        const timer = this.timer = new Timer(timeLeft, (() => {
            timer.runAction(StandartAnimations.disappear(timer));
        }), {
            timerPosition: styles.countdown,
            timerBg: bundles.bonus_level.frames.bonus_timer_bg_png,
            timerIcon: bundles.bonus_level.frames.bonus_timer_icon_png,
            showHours: false
        });
        timer.fitTo(styles.width, styles.height);
        timer.setAlignment(this.isVertical ? styles.vertical : styles);
        this.addChild(timer);
    },

    open: function (amount) {
        this.runAction(new cc.Sequence(
            new cc.DelayTime(0.5),
            new cc.CallFunc(() => {
                cleverapps.aims.showDelta(amount, this.chest, {
                    icon: new Reward("hard", amount).getSmallIcon(),
                    type: "hard"
                });
            })
        ));
      
        this.chest.setAnimation(0, "open", false);
    },

    show: function (positions) {
        const scene = cleverapps.Scenes.GetRunningScene();

        const gameComponent = typeof Match3SceneComponent !== "undefined" && cleverapps.Scenes.GetSceneComponent(Match3SceneComponent)
            || typeof SegmentSolitaireSceneComponent !== "undefined" && cleverapps.Scenes.GetSceneComponent(SegmentSolitaireSceneComponent);
        const movesView = gameComponent && gameComponent.movesView;

        const position = cleverapps.UI.findPosition(this, {
            preferredPositions: cleverapps.toArray(positions),
            avoidNodes: [ComponentUtils.findComponentByName(scene, "UpMenuController").getMenuBar(), movesView].filter(Boolean)
        });

        this.setVisible(true);
        this.setAlignment(position);
    },

    hide: function () {
        this.setVisible(false);
    },

    remove: function (callback) {
        this.chest.runAction(new cc.Spawn(
            new cc.FadeOut(0.3),
            new cc.Sequence(
                new cc.ScaleTo(0.3, 0.5).easing(cc.easeBackIn()),
                new cc.CallFunc(callback),
                new cc.RemoveSelf()
            )
        ));

        this.timer && this.timer.runAction(new cc.Sequence(
            new cc.Spawn(
                new cc.FadeOut(0.3),
                new cc.ScaleTo(0.3, 0.5).easing(cc.easeBackIn())
            ),
            new cc.RemoveSelf()
        ));
    }
});

cleverapps.styles.BonusLevelChest = {
    column: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: 0 }
    },

    timer: {
        width: 180,
        height: 60,
        x: { align: "center", dx: 0 },
        y: { align: "top", dy: 140 },

        countdown: {
            x: { align: "center", dx: 8 },
            y: { align: "center", dy: 3 }
        },

        vertical: {
            x: { align: "center", dx: 0 },
            y: { align: "top", dy: 10 }
        }
    },

    chest: {
        x: { align: "center", dx: 10 },
        y: { align: "top", dy: 425 },

        vertical: {
            x: { align: "center", dx: 0 },
            y: { align: "top", dy: 150 }
        }
    }
};